
import { DatePipe } from '@angular/common';

import { BaseComponent } from '../../shared/base-components/base.component';
import { Directive } from '@angular/core';

@Directive()
export class TitleViewBaseComponent extends BaseComponent {
    public loaded: boolean;
    public title: any;
    public titleMessage: string;
    public brandMessage: string;
    public lienMessage: string;
    public hasTitle: boolean;
    public hasBrands: boolean;
    public hasLiens: boolean;
    protected hasProhibitions: boolean;
    protected datePipe: DatePipe;
    public canTransfer: boolean;
    public titleViewType: string;

    constructor() {
        super();
        this.datePipe = new DatePipe('en-US');
    }

    public ngOnInit() {

    }

    protected setTitleInfo(data) {
        this.title = data;
        this.formatDate(this.title);
        this.hasTitle = true;
        this.hasBrands = data.brands.length > 0;
        this.hasLiens = data.lienInformation.length > 0;
        this.hasProhibitions = data.prohibitionIndicator;
        this.canTransfer = !(this.hasBrands || this.hasLiens || this.hasProhibitions);
        this.setMessages();
    }

    protected formatDate(title: any) {
        this.title.titleIssueDateFormatted = this.datePipe.transform(title.titleIssueDate, 'MM/dd/y');
        if (this.title.titleIssueDateFormatted.valueOf() == '01/01/1900') {
            this.title.titleIssueDateFormatted = 'Title On File';
        }
    }

    protected setMessages() {
        this.titleMessage = this.title.clearStatus;
        this.brandMessage = this.getTitleDetailMessage('brands', this.hasBrands);
        this.lienMessage = this.getTitleDetailMessage('liens', this.hasLiens);
    }

    protected getTitleDetailMessage(type: string, hasContents: boolean): string {
        return 'This vehicle has ' + (hasContents ? 'one or more' : 'no') + ' ' + type + '.';
    }
}
